'use client';

import { faLink } from '@fortawesome/pro-light-svg-icons';

import { Button } from '@/components/ui/button/button.component';
import { Icon } from '@/components/ui/icon.component';
import { useToast } from '@/components/ui/use-toast';
import { copyToClipboard } from '@/app/(main)/(pages)/(institucional)/blog/[slug]/_utils/copy-to-clipboard.util';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface CopyPostToClipBoardProps {
  url: string;
}

export function CopyPostToClipboard({ url }: CopyPostToClipBoardProps) {
  const { toast } = useToast();

  const onCopyLink = () => {
    copyToClipboard(url);
    toast.success('Link copiado.');
  };

  return (
    <Button variant="text" onClick={onCopyLink} className="w-auto" data-testid="copy--copy-post-to-clipboard" data-analytics-event={AnalyticsEnum.CLICK_CLICK_BOARD}>
      <Icon icon={faLink} size="1x" className="text-xl hover:scale-125" />
    </Button>
  );
}
